import React from 'react';
import LeftSideWrapper from "./LeftSide";
import RightSide from "./RightSide";

const Dashboard = () => {

    return <div className="dash-wrapper lotto12v2">
        <LeftSideWrapper />
        <RightSide />
    </div>
};

export default Dashboard;